// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import './assets/style/reset.css'
import './assets/style/global.css'
import 'swiper/dist/css/swiper.min.css'
import Swiper from 'swiper'

import { pagination,Tabs,Form,FormItem,Input,Button } from 'element-ui'

Vue.config.productionTip = false

// 将 Swiper 挂载到 Vue 原型上，方便全局使用
Vue.prototype.$Swiper = Swiper

Vue.use(pagination)
Vue.use(Tabs);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Input);
Vue.use(Button);
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js